import { useLoginAttemptsStore } from "./loginAttempts";
import { useAuthStore } from "./useAuth";
import { useConfigStore } from "./useConfig";
import { useExamTabsStore } from "./useExamTabsStore";
import { useModules } from "./useModulesStore";
import { useModuleIdStore } from "./useModuleStore";
import { usePracticeTestIdStore } from "./usePracticeTest";
import { useUserStore } from "./useUser";

export const clearAllStores = () => {
  useAuthStore.getState().clearAuthStore();
  useUserStore.getState().clearUserStore();
  usePracticeTestIdStore.getState().clearPracticeTextIdStore();
  useExamTabsStore.getState().clearPracticeTextIdStore();
  useConfigStore.getState().clearConfigStore();
  useModuleIdStore.getState().clearModuleIdStore();
  useModules.getState().modules.clear();
  useLoginAttemptsStore.getState().clearStoreLoginAttempts();
};
